<template>
  <div class="row goal-summary">
    <div class="col-md-4">
      <div class="card card-office-goal">
        <div class="card-body" :class="{'text-center': !personal}">
          <img :src="iconGoal" alt="Office Goal">
          <h3 class="font-weight-bold">{{ totalGoal }}</h3>
          <p class="mb-0">Office Goal</p>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card card-office-actual">
        <div class="card-body" :class="{'text-center': !personal}">
          <img :src="iconActual" alt="Office Actual">
          <h3 class="font-weight-bold">{{ totalActual }}</h3>
          <p class="mb-0">Office Actual</p>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card card-office-pending">
        <div class="card-body" :class="{'text-center': !personal}">
          <img :src="iconPending" alt="Office Pending">
          <h3 class="font-weight-bold">{{ getTotalPending() }}</h3>
          <p class="mb-0">Pending</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfficeGoalsSummary',
  props: {
    totalGoal: {
      type: Number,
      default: 0
    },
    totalActual: {
      type: Number,
      default: 0
    },
    totalPending: {
      type: Number,
      default: 0
    },
    personal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconGoal: '/images/icons-goals/ranking.svg',
      iconActual: '/images/icons-goals/medal-star.svg',
      iconPending: '/images/icons-goals/note-2.svg',
    }
  },
  methods: {
    getTotalPending() {
      if (this.totalActual > this.totalGoal) {
        return 0;
      }

      return this.totalPending;
    }
  }
}
</script>